import React, { useState, useEffect, useRef } from 'react';

const SearchableSelect = ({
	isLoading,
	options = [],
	onSelect,
	onSearch,
	placeholder,
	searchTerm,
	setSearchTerm,
	isSearchIconClicked = false,
	isFromTeamPage = false,
	saveSearchForHistory,
	selectedSearchOption,
	isTechpackOpen,
	searchType
}) => {
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [isShowRecentSearch, setIsShowRecentSearch] = useState(isSearchIconClicked);
	const inputRef = useRef(null);
	const optionsContainerRef = useRef(null);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.focus();
		}
	}, [inputRef, isTechpackOpen]);

	useEffect(() => {
		if (isLoading) {
			setSelectedIndex(0);
		}
	}, [isLoading]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				inputRef.current &&
				!inputRef.current.contains(event.target) &&
				optionsContainerRef.current &&
				!optionsContainerRef.current.contains(event.target)
			) {
				setIsShowRecentSearch(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleInputChange = (event) => {
		let encodedName;
		if (selectedSearchOption === 'QR_CODE') {
			encodedName = event.target.value.split(';')[1];
		} else {
			encodedName = event.target.value;
		}
		onSearch(encodedName);
		setSearchTerm(encodedName);
	};

	const onSelectClick = (option) => {
		const encodedLabel = searchType === 'DESIGN_NO' ? option?.systemReferenceNumber : option?.label;
		setSearchTerm(encodedLabel);
		onSelect({ ...option, label: encodedLabel });
		saveSearchForHistory(option);
	};

	const handleKeyDown = (event) => {
		if (event.key === 'ArrowUp') {
			event.preventDefault();
			setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
		} else if (event.key === 'ArrowDown') {
			event.preventDefault();
			setSelectedIndex((prevIndex) => Math.min(prevIndex + 1, options.length - 1));
		} else if (event.key === 'Enter') {
			onSelectClick(options[selectedIndex]);
		}

		// Scroll to the selected option
		const selectedOptionElement = document.querySelector('.options-list li.selected');
		if (selectedOptionElement) {
			selectedOptionElement.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest'
			});
		}
	};

	return (
		<div>
			<div className="seacrh-input">
				<input
					placeholder={placeholder}
					className="search-input"
					type="text"
					autoComplete="off"
					ref={inputRef}
					value={searchTerm}
					onChange={handleInputChange}
					onClick={() => setIsShowRecentSearch(true)}
					onKeyDown={options?.length > 0 && !isLoading ? handleKeyDown : null}
				/>
			</div>

			{isShowRecentSearch && !isLoading && (
				<ul className="options-list collection-option-list shadow-8dp" ref={optionsContainerRef}>
					<h4 className="search-title regular-14 gray_dark_02 weight-600 mb-0">
						{searchTerm && searchTerm.length > 0
							? searchType === 'DESIGN_NO'
								? 'Search Result: Nitex ref'
								: 'Search Result: Buyer ref'
							: 'Recent Search'}
					</h4>
					{options.length > 0 ? (
						[...new Set(options)].map((product, index) => (
							<li
								key={index}
								className={`${searchType === 'BUYER_DESIGN_NO' && !product?.systemReferenceNumber ? 'mb-12 d-none' : 'mb-12'}`}
								onClick={() => onSelectClick(product)}
							>
								<p className="regular-14 gray_dark_01 weight-600 mb-1">
									{searchType === 'DESIGN_NO'
										? product.systemReferenceNumber
										: product.label}
								</p>
								<p className="regular-12 gray_dark_02 m-0">{product.collectionName}</p>
							</li>
						))
					) : (
						<li className="selected text-align--center">
							No {isFromTeamPage ? 'members' : 'designs'}
						</li>
					)}
				</ul>
			)}
		</div>
	);
};

export default SearchableSelect;
